import * as countryActionTypes from "./countryActionTypes";

const initialState = {
  countryList: [],
  error: null,
  centralWarehouses: [],
  selectedWarehouse: '',
  warehouseError: null,
  countries: [],
  countriesError: null,
  whCountriesMappings: new Map(),
  whCountriesMappingsError: null,
};

const loadCountry = (state, action) => {
  return {
    ...state,
    countryList: action.value,
  };
};

const addCountry = (state, action) => {
  return {
    ...state,
    countryList: state.countryList.concat(action.value),
  };
};

const failedToLoadCountry = (state, action) => {
  return {
    countryList: [],
    error: action.value,
  };
};

const updateCutOff = (state, action) => {
  const title = action?.value?.title;
  const newCountryList = state.countryList.map((c) => {
    if (c.title === title && action?.value?.type === "time") {
      c.cut_off_time = action?.value?.type_data;
    } else if (c.title === title && action?.value?.type === "day") {
      c.holiday = action?.value?.type_data;
    } else if (c.title === title && action?.value?.type === "disable") {
      c.cut_off_time = "";
    }
    return c;
  });

  return {
    ...state,
    countryList: newCountryList,
  };
};

const loadCentralWarehouses = (state, action) => {
  return {
    ...state,
    centralWarehouses: action.value,
    warehouseError: null,
  };
};

const failedToLoadCentralWarehouses = (state, action) => {
  return {
    ...state,
    centralWarehouses: [],
    warehouseError: action.value,
  };
};

const setSelectedWarehouse = (state, action) => {
  return {
    ...state,
    selectedWarehouse: action.value,
  };
};

const loadCountries = (state, action) => {
  return {
    ...state,
    countries: action.value,
    countriesError: null,
  };
};

const failedToLoadCountries = (state, action) => {
  return {
    ...state,
    countries: [],
    countriesError: action.value,
  };
};

const loadWhCountryMappings = (state, action) => {
  return {
    ...state,
    whCountriesMappings: action.value,
    whCountriesMappingsError: null,
  };
};

const failedToLoadWhCountryMappings = (state, action) => {
  return {
    ...state,
    whCountriesMappings: new Map(),
    whCountriesMappingsError: action.value,
  };
};

const updateWhCountryMappings = (state, action) => {
  const { warehouse, countries } = action.value;
  const newMappings = new Map(state.whCountriesMappings);
  newMappings.set(warehouse, countries);
  return {
    ...state,
    whCountriesMappings: newMappings,
  };
};

const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case countryActionTypes.LOAD_COUNTRY:
      return loadCountry(state, action);
    case countryActionTypes.ADD_COUNTRY:
      return addCountry(state, action);
    case countryActionTypes.LOAD_COUNTRY_FAILED:
      return failedToLoadCountry(state, action);
    case countryActionTypes.UPDATE_CUTOFF_TIME:
      return updateCutOff(state, action);
    case countryActionTypes.LOAD_CENTRAL_WAREHOUSES:
      return loadCentralWarehouses(state, action);
    case countryActionTypes.LOAD_CENTRAL_WAREHOUSES_FAILED:
      return failedToLoadCentralWarehouses(state, action);
    case countryActionTypes.SET_SELECTED_WAREHOUSE:
      return setSelectedWarehouse(state, action);
    case countryActionTypes.LOAD_COUNTRIES:
      return loadCountries(state, action);
    case countryActionTypes.LOAD_COUNTRIES_FAILED:
      return failedToLoadCountries(state, action);
    case countryActionTypes.LOAD_WH_COUNTRY_MAPPINGS:
      return loadWhCountryMappings(state, action);
    case countryActionTypes.LOAD_WH_COUNTRY_MAPPINGS_FAILED:
      return failedToLoadWhCountryMappings(state, action);
    case countryActionTypes.UPDATE_WH_COUNTRY_MAPPINGS:
      return updateWhCountryMappings(state, action);
    default:
      return state;
  }
};

export default countryReducer;
